<template>
  <router-view v-if="isShowcase" />
  <PublicSite v-else-if="$route.meta.layout === 'public'" />
  <PortalSite v-else-if="$route.meta.layout === 'portal'" />
  <AuthSite v-else-if="$route.meta.layout === 'auth'" />
  <template v-else>
    <navbar />
    <router-view />
    <Footer />
  </template>
</template>

<script>
import PublicSite from '@/components/public/PublicSite.vue';
import PortalSite from '@/components/portal/PortalSite.vue';
import AuthSite from '@/components/auth/AuthSite.vue';
import navbar from '@/components/layouts/navbar.vue';
import Footer from '@/components/layouts/footer.vue';
require("../src/assets/scss/style.min.css");

export default {
  name: 'App',
  computed: {
    isShowcase() { return process.env.NODE_ENV === 'development' && this.$route.meta.layout === 'showcase'; },
  },
  components: {
    PublicSite,
    PortalSite,
    AuthSite,
    navbar,
    Footer,
  }
}
</script>